<template>
  <div>
    <h2 class="mb-4">จัดการผู้ใช้งาน</h2>
    <CRow>
      <CCol md="3">
        <CInput
          v-model="word"
          placeholder="ค้นหา"
          @keyup.enter="handleSearch"
        />
      </CCol>
      <CCol md="3">
        <CSelect :value.sync="filterSelected" :options="filter" />
      </CCol>
      <CCol md="6">
        <div class="flex space-between mb-3">
          <CButton color="primary" @click="handleSearch"
            ><i class="fas fa-search"></i> ค้นหา
          </CButton>
          <CButton color="info" @click="handleDownload" :disabled="downloading">
            <i
              :class="
                downloading ? 'fas fa-spinner fa-spin' : 'far fa-file-excel'
              "
            ></i>
            {{ downloading ? 'Downloading...' : 'Excel download' }}
          </CButton>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="12">
        <vue-good-table
          mode="remote"
          :isLoading.sync="loading"
          :columns="columns"
          :rows="rows"
          :sort-options="{
            enabled: true,
            initialSortBy: defaultSearch.sort
          }"
          @on-sort-change="onSortChange"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'image'">
              <CImg
                :src="props.row.image"
                width="67"
                height="67"
                class="mx-auto"
                placeholderColor="lightgray"
                block
              />
            </span>
            <span v-else-if="props.column.field == 'registerDate'">
              {{ props.row.registerDate | datetimeFormat }}
            </span>
            <span v-else-if="props.column.field == 'statusName'">
              {{ props.row.statusName | userStatusFormat }}
            </span>
            <span v-else-if="props.column.field == 'action'">
              <CButton
                color="info"
                variant="outline"
                size="sm"
                class="m-1"
                @click="$refs.notiModal.show(props.row.id)"
              >
                <i class="fa fa-bell"></i>
                <span class="sr-only">ส่งข้อความถึงอาสาสมัครรายนี้</span>
              </CButton>

              <CButton
                color="info"
                size="sm"
                class="m-1"
                @click="$refs.infoModal.show(props.row.id)"
              >
                <i class="fa fa-info"></i>
                <span class="sr-only">ดูข้อมูลผู้ใช้งาน</span>
              </CButton>
              <CButton
                color="warning"
                size="sm"
                class="m-1"
                @click="$refs.editModal.show(props.row)"
              >
                <i class="fa fa-pen"></i>
                <span class="sr-only">แก้ไขข้อมูลผู้ใช้งาน</span>
              </CButton>
              <CButton
                color="danger"
                variant="outline"
                size="sm"
                class="m-1"
                @click="
                  $refs.deleteModal.show(props.row.id, props.row.fullName)
                "
              >
                <i class="fa fa-trash"></i>
                <span class="sr-only">ลบผู้ใช้งานรายนี้</span>
              </CButton>
            </span>
            <span v-else class="h6">
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="12">
        <vue-ads-pagination
          :total-items="total"
          :max-visible-pages="5"
          :items-per-page="10"
          :page="search.page"
          :loading="loading"
        >
          <template slot-scope="props">
            <div class="vue-ads-pr-2 vue-ads-leading-loose">
              รายการที่ {{ props.start | decimalFormat }} ถึง
              {{ props.end | decimalFormat }} จาก
              {{ props.total | decimalFormat }} รายการ
            </div>
          </template>
          <template slot="buttons" slot-scope="props">
            <vue-ads-page-button
              v-for="(button, key) in props.buttons"
              :key="key"
              v-bind="button"
              @page-change="pageChange(button.page)"
            />
          </template>
        </vue-ads-pagination>
      </CCol>
    </CRow>

    <UserNotiModal ref="notiModal" />
    <UserInfoModal ref="infoModal" />
    <UserEditModal ref="editModal" :onComplete="getList" />
    <DeleteModal ref="deleteModal" :onConfirm="deleteUser" />
  </div>
</template>

<script>
import moment from 'moment'

import UserNotiModal from '../modal/UserNotiModal'
import UserEditModal from '../modal/UserEditModal'
import UserInfoModal from '../modal/UserInfoModal'
import DeleteModal from '../modal/DeleteModal'

import apiUser from '@/apis/user'

export default {
  name: 'Rfb3',
  components: {
    UserNotiModal,
    UserEditModal,
    UserInfoModal,
    DeleteModal
  },
  data() {
    return {
      loading: false,
      downloading: false,
      word: '',
      search: {},
      defaultSearch: {
        page: 0,
        limit: 10,
        sort: {
          field: 'userName',
          type: 'asc'
        }
      },
      total: 0,
      filterSelected: 'userName',
      filter: [
        { value: 'userName', label: 'Username' },
        { value: 'fullName', label: 'ชื่อ-นามสกุล' },
        { value: 'registerDate', label: 'วันที่สมัครสมาชิก' },
        { value: 'type', label: 'ประเภทผู้ใช้งาน' }
      ],
      columns: [
        {
          label: 'ลำดับ',
          field: 'no',
          width: '50px',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false
        },
        {
          label: 'รูปภาพ',
          field: 'image',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'align-middle',
          width: '100px'
        },
        {
          label: 'Username',
          field: 'userName',
          width: '160px'
        },
        {
          label: 'ชื่อ-นามสกุล',
          field: 'fullName',
          width: '220px'
        },
        {
          label: 'วันที่สมัครสมาชิก ',
          field: 'registerDate',
          width: '200px'
        },
        {
          label: 'ประเภทผู้ใช้งาน',
          field: 'statusName',
          width: '130px'
        },
        {
          field: 'action',
          sortable: false,
          tdClass: 'text-center align-middle',
          width: '180px'
        }
      ],
      rows: []
    }
  },
  created() {
    this.search = Object.assign({}, this.defaultSearch)
  },
  methods: {
    handleSearch() {
      this.search = Object.assign({}, this.defaultSearch)
      if (this.word) this.search[this.filterSelected] = this.word

      this.getList()
    },
    handleDownload() {
      this.downloading = true
      apiUser
        .download()
        .then((data) => {
          const blob = new Blob([data], { type: 'text/csv' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)

          link.target = '_blank'
          link.download = `${moment().format('YYYYMMDDHHmm')}_users.csv`
          link.click()
          URL.revokeObjectURL(link.href)

          this.downloading = false
        })
        .catch(() => {
          this.downloading = false
        })
    },
    pageChange(page) {
      this.search.page = page
      this.getList()
    },
    onSortChange(params) {
      this.search.sort = params[0]
      this.getList()
    },
    getList() {
      this.loading = true
      apiUser
        .getList(this.search)
        .then((result) => {
          this.total = result.data.totalDocs
          this.rows = []
          for (let i = 0; i < result.data.docs.length; i++) {
            const item = result.data.docs[i]
            this.rows.push({
              no: this.search.page * this.search.limit + i + 1,
              id: item.id,
              image: item.userProfileUrl,
              userName: item.userName,
              fullName: item.fullName,
              registerDate: item.registerDate,
              statusName: item.statusName
            })
          }
          this.loading = false
        })
        .catch(() => {
          this.rows = []
          this.loading = false
        })
    },
    deleteUser(id) {
      this.loading = true
      apiUser
        .remove(id)
        .then(() => {
          this.getList()
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
